import type { BulkMaterial } from '#domain/BulkMaterial.ts';
import type { CargoMaterial } from '#domain/CargoMaterial.ts';
import type { Material } from '#domain/Material.ts';
import type { StopDetails } from '#domain/Stop.ts';

export const hasDeviation = (target?: number, actual?: number) => {
    if (target === undefined) {
        return false;
    }
    return actual != null && target !== actual;
};

const hasCargoMaterialDeviation = (material: CargoMaterial): boolean => {
    return (
        hasDeviation(material.quantity.target, material.quantity.loaded) ||
        hasDeviation(material.quantity.target, material.quantity.unloaded) ||
        hasDeviation(material.weight?.target, material.weight?.loaded) ||
        hasDeviation(material.weight?.target, material.weight?.unloaded) ||
        hasDeviation(material.loadingMeter?.target, material.loadingMeter?.loaded) ||
        hasDeviation(material.loadingMeter?.target, material.loadingMeter?.unloaded)
    );
};

const hasBulkMaterialDeviation = (material: BulkMaterial): boolean => {
    return (
        hasDeviation(material.quantity.target, material.quantity.loaded) ||
        hasDeviation(material.quantity.target, material.quantity.unloaded)
    );
};

export const hasStopDeviation = (stop: StopDetails): boolean => stop.materials.some(item => hasMaterialDeviation(item));

export const hasMaterialDeviation = (material: Material) => {
    switch (material.type) {
        case 'cargo-material':
            return hasCargoMaterialDeviation(material);
        case 'bulk-material':
            return hasBulkMaterialDeviation(material);
    }
};
